<template>
  <div style="display: flex; gap: 30px; flex-wrap: wrap; margin: 20px 0">
    <div
      style="
        flex: 0 1 45%;
        box-sizing: border-box;
        border: 1px solid #e8eaec;
        padding: 20px;
        border-radius: 4px;
      "
    >
      <h3 style="margin-bottom: 20px">对照组</h3>
      <div style="display: flex; align-items: center; gap: 10px">
        <span>三方支付链路</span>
        <RadioGroup
          :value="getControlPayLinkType()"
          type="button"
          button-style="solid"
          @on-change="handleControlPayLinkTypeChange"
        >
          <Radio :label="0" :disabled="disabled">聚合支付</Radio>
          <Radio :label="1" :disabled="disabled">分步支付</Radio>
        </RadioGroup>
      </div>
    </div>

    <div
      v-for="(group, index) in formData.groups"
      :key="index"
      style="
        flex: 0 0 45%;
        box-sizing: border-box;
        border: 1px solid #e8eaec;
        padding: 20px;
        border-radius: 4px;
      "
    >
      <h3 style="margin-bottom: 20px">实验组{{ index + 1 }}</h3>
      <div style="display: flex; align-items: center; gap: 10px">
        <span>三方支付链路</span>
        <RadioGroup
          :value="getPayLinkType(index)"
          type="button"
          button-style="solid"
          @on-change="handlePayLinkTypeChange(index, $event)"
        >
          <Radio :label="0" :disabled="disabled">聚合支付</Radio>
          <Radio :label="1" :disabled="disabled">分步支付</Radio>
        </RadioGroup>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayLinkConfig',
  props: {
    formData: {
      type: Object,
      required: true
    },
    experimentGroupCount: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getControlPayLinkType() {
      const controlGroup = this.formData.controlGroupParam || {}
      return controlGroup.payLinkType !== undefined ? controlGroup.payLinkType : 0
    },
    handleControlPayLinkTypeChange(value) {
      if (this.disabled) return
      this.$set(this.formData.controlGroupParam, 'payLinkType', value)
    },
    getPayLinkType(index) {
      const group =
        Array.isArray(this.formData.groups) && this.formData.groups[index]
          ? this.formData.groups[index]
          : null
      const params = group && group.experimentGroupParam
      return params && params.payLinkType !== undefined ? params.payLinkType : 0
    },
    handlePayLinkTypeChange(index, value) {
      if (this.disabled) return

      const group =
        Array.isArray(this.formData.groups) && this.formData.groups[index]
          ? this.formData.groups[index]
          : null
      if (!group || !group.experimentGroupParam) return

      this.$set(group.experimentGroupParam, 'payLinkType', value)
    },
    validate() {
      return true
    }
  }
}
</script>

<style scoped lang="less"></style>
